var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.5204 20.4083C31.5204 22.9395 29.4598 25.0001 26.9286 25.0001H22.3367V15.8164H26.9286C29.4598 15.8164 31.5204 17.877 31.5204 20.4083ZM45.2959 11.2246V38.7756C45.2959 42.9944 41.8616 46.4287 37.6429 46.4287H13.1531C8.9343 46.4287 5.5 42.9944 5.5 38.7756V11.2246C5.5 7.00583 8.9343 3.57153 13.1531 3.57153H37.6429C41.8616 3.57153 45.2959 7.00583 45.2959 11.2246ZM34.5816 20.4083C34.5816 16.1895 31.1473 12.7552 26.9286 12.7552H19.2755V37.245H22.3367V28.0613H26.9286C31.1473 28.0613 34.5816 24.627 34.5816 20.4083Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/parking.f6c2d911bef54ca021931a6922b0f3d3.svg";
export { ForwardRef as ReactComponent };